/**
 * 模块名称: 项目设置 
 * @author zhuyan@372163.com
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Projectsetting from './Projectsetting'

const ProjectsettingIndex = ({ match, history }) => {

  return (
    <div>
      <Switch>
        <Route path={match.path + '/projectsetting'} component={Projectsetting} />
        <Route component={Projectsetting} />
      </Switch>
    </div>
  )
}

export default ProjectsettingIndex